import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { BehaviorSubject, Subject } from 'rxjs';
import { FuelTankDto } from 'src/app/shared/flight-log-api/fuel-tanks/fuel-tank-client.model';
import { FuelTankHttpClient } from 'src/app/shared/flight-log-api/fuel-tanks/fuel-tank-client.service';
import { SelectItem } from 'src/util/ui/forms';

function createOption(selectedValue: string): (fuelTank: FuelTankDto) => SelectItem {
  return (fuelTank) => {
    const label = `${fuelTank.locationName} - ${fuelTank.name}`;
    const value = fuelTank.id;
    const selected = selectedValue === value;
    return { value: fuelTank.id, label, selected };
  };
}

@Component({
  selector: 'fl-amgh-fuel-tank-select',
  templateUrl: './amgh-fuel-tank-select.component.html',
  styleUrls: ['./amgh-fuel-tank-select.component.scss'],
})
export class AmghFuelTankSelectComponent implements OnInit {
  @Input()
  public fuelTankId: UntypedFormControl;
  public options$: BehaviorSubject<SelectItem[]> = new BehaviorSubject<SelectItem[]>([]);
  public searchTerm$: Subject<string> = new Subject<string>();

  get none(): null {
    return null;
  }

  constructor(private _fuelTanks: FuelTankHttpClient) {}

  public ngOnInit() {
    this._fuelTanks.getAll().subscribe((fuelTanks) => {
      this.options$.next(fuelTanks.map(createOption(this.currentSelectionValue)));
    });
  }

  get currentSelectionValue() {
    return this.fuelTankId != null ? this.fuelTankId.value : 'none';
  }
}
